import { render } from "./NewsLetter.vue?vue&type=template&id=72fc5ba1&scoped=true"
import script from "./NewsLetter.vue?vue&type=script&lang=js"
export * from "./NewsLetter.vue?vue&type=script&lang=js"

import "./NewsLetter.vue?vue&type=style&index=0&id=72fc5ba1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fc5ba1"]])

export default __exports__